import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://f36cea0b6ad845a5b22a7f6a84311321@neosylva.bugsink.com/1',
  environment: `front/${import.meta.env.VITE_STAGING_MODE}`,
  integrations: [Sentry.browserTracingIntegration()],
  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: [/^\//, /^https:\/\/neosylva\.alwaysdata\.net\//],
});
